import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import axios from "axios";

const ContentContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function ContentProvider({ children }) {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchAll = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/content`);
      const map = {};
      res.data.forEach(item => { map[item.section] = item.data; });
      setContent(map);
    } catch (e) {
      console.error("Error loading content:", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchAll(); }, [fetchAll]);

  const updateSection = async (section, data) => {
    await axios.put(`${API}/content/${section}`, { data }, { withCredentials: true });
    setContent(prev => ({ ...prev, [section]: data }));
  };

  const refreshContent = fetchAll;

  // Memoize context value to avoid unnecessary re-renders of consumers
  const contextValue = useMemo(
    () => ({ content, loading, updateSection, refreshContent }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [content, loading]
  );

  return (
    <ContentContext.Provider value={contextValue}>
      {children}
    </ContentContext.Provider>
  );
}

export function useContent() {
  return useContext(ContentContext);
}
